/** @format */

import {TooltipExtraRow} from 'components/charts/multiline-chart/model/tooltip';

import {divideBySpaces} from 'helpers/numberHelpers';

import {ChartIds} from '../../models/chartIds';
import {getSensorGroupByChartId} from '../../helpers/sensors/getSensorGroupByChartId';
import {MAX_TOOLTIP_EXTRA_ROWS} from '../../constants/common';
import {SensorGroupsList} from '../../helpers/sensors/types';

interface TemporaryResult {
  label: string;
  value: number;
}

const getTooltipPointSensor = (
  chartId: ChartIds,
  sensorGroup?: SensorGroupsList,
): TooltipExtraRow[] => {
  const group = getSensorGroupByChartId(chartId);

  if (!sensorGroup || !sensorGroup[group]) {
    return [];
  }

  const detailed = sensorGroup[group].detailed;
  let result: TemporaryResult[] = detailed.map(item => ({
    label: item.name,
    value: item.value,
  }));

  if (result.length > MAX_TOOLTIP_EXTRA_ROWS) {
    const filteredResult = result.slice(0, MAX_TOOLTIP_EXTRA_ROWS - 1);
    const restResult = result.slice(MAX_TOOLTIP_EXTRA_ROWS - 1);
    const primaryValue = restResult.reduce((acc, cur) => {
      return acc + cur.value;
    }, 0);
    filteredResult.push({
      label: String(restResult.length),
      value: primaryValue,
    });
    result = filteredResult;
  }

  return result.map(row => ({
    label: row.label,
    value: {
      primary: divideBySpaces(row.value),
    },
  }));
};

export default getTooltipPointSensor;
